/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';

const Filtro = ({ dataFilter, handleClick, label }) => {
  const optionsInOrder = dataFilter.options.sort((a, b) => ((a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)));
  return (
    <>
      <h3 className='name-filter color-dinamico'>{label}</h3>
      {optionsInOrder.map((option) => /*!option.active &&*/ (
        <div
          key={option.value}
          onClick={() => handleClick(option)}
          className={`option-value ${option.active ? 'active' : ''}`}
        >
          <span>{option.value}</span>
        </div>
      ))}
      <br />
    </>
  );
};

export default Filtro;
